import React from "react"
import { useCookies } from "react-cookie"
import { useDispatch, useSelector } from "react-redux"
import { useIntl } from "react-intl"

import { logoutAction } from "../../../../redux/slices/authSlice";
import { toggleSwitchEnvAction } from "../../../../redux/slices/configSlice";

import CustomLink from "../../CustomLink"
import CustomButton from "../../CustomButton"

import { GA_EVENTS } from "../../../../constants/analytics"
import { API_ENV } from "../../../../constants";

const GeneralSettingsSidebar = ({ back }) => {
  // eslint-disable-next-line
  const [_, __, removeCookie] = useCookies(["token"])
  const dispatch = useDispatch()
  const { environment } = useSelector((state) => state.config);

  const { formatMessage } = useIntl()

  const items = [
    // {
    //   name: "API Keys",
    //   path: "/api-keys",
    //   trackingEvent: GA_EVENTS.SIDE_BAR.SETTINGS,
    // },
    {
      name: `Switch to ${environment === API_ENV.DEV ? API_ENV.PRD : API_ENV.DEV} Environment`,
      onClick: () => dispatch(toggleSwitchEnvAction()),
    },
    {
      name: formatMessage({ id: "sidebar.logout" }),
      onClick: () => {
        removeCookie("token", { path: "/" })
        dispatch(logoutAction())
      },
      trackingEvent: GA_EVENTS.SIDE_BAR.LOGOUT
    },
  ]

  return (
    <div className="general-settings">
      {items
        ?.filter((val) => val)
        .map((item) =>
          item.onClick ? (
            <CustomButton
              key={`sidebar-${item.name}`}
              className="general-settings__item"
              onClick={item.onClick}
              trackingEvent={item.trackingEvent ?? GA_EVENTS.GENERAL.SIDE_BAR_CLICKED}
            >
              {item.name}
            </CustomButton>
          ) : (
            <CustomLink
              key={`sidebar-${item.name}`}
              to={item.path}
              className="general-settings__item"
              trackingEvent={item.trackingEvent ?? GA_EVENTS.GENERAL.SIDE_BAR_CLICKED}
            >
              {item.name}
            </CustomLink>
          ),
        )}
    </div>
  )
}

export default GeneralSettingsSidebar;
